import React from 'react'

const Header = () => {
  return (
    <div className='app-header'>
      <h1>My List</h1>
    </div>
  )
}

export default Header
